import { generateKeys } from '../utils';
export const tradingAlertsTypes = generateKeys({
    live: {
        label: 'Live',
        value: 'live',
    },
    closed: {
        label: 'Closed',
        value: 'closed',
    },
});
export const tradingAlertsActions = generateKeys({
    buy: {
        label: 'BUY',
        value: 'buy',
    },
    sell: {
        label: 'SELL',
        value: 'sell',
    },
});
export const tradingAlertsStatuses = generateKeys({
    active: {
        label: 'Active',
        value: 'active',
    },
    getReady: {
        label: 'Get Ready',
        value: 'get_ready',
    },
});
export const tradingAlertsResults = generateKeys({
    hitTP: {
        label: 'Hit TP',
        value: 'hitTP',
    },
    hitSL: {
        label: 'Hit SL',
        value: 'hitSL',
    },
    noHit: {
        label: 'No Hit',
        value: 'noHit',
    },
});
